<template>
  <div
    class="promo-code-form"
    v-if="isShowPromoCodeForm && !hasAppliedFormaCode"
  >
    <span class="promo-code-form__label"> Enter Giftcard </span>

    <div class="promo-code-form__text-wrapper">
      <div class="promo-code-form__text-wrapper--main">
        <input
          type="text"
          v-model="code"
          v-mask="FORMA_CODE.FORMAT"
          class=""
          :class="{
            'tw-border-green-500': isValid,
            'tw-border-red-500': isValid === false,
          }"
          :disabled="hasAppliedFormaCode || isLoading"
        />

        <IconLoading v-if="isLoading" />

        <span
          class="
            tw-absolute tw-left-0 tw-bottom-[-17px] tw-text-xs tw-text-red-500
          "
          v-if="isValid === false"
        >
          Giftcard not valid
        </span>
      </div>

      <button
        @click="applyCoupon"
        :disabled="code.length !== FORMA_CODE.FORMAT.length || isLoading"
      >
        Apply
      </button>
    </div>
  </div>
</template>

<script>
// libs
import _ from "lodash";
import { mapState } from "vuex";

// services
import { OnboardingService } from "@/services/onboarding.service";

// components
import IconLoading from "@/components/icon/IconLoading";

// utils
import $cookies from "@/utils/cookies";

// constants
import { COOKIES, FORMA_CODE } from "@/constants";

export default {
  props: {
    getOnboarding: {
      type: Function,
      required: true,
    },
  },
  components: {
    IconLoading,
  },
  data() {
    return {
      FORMA_CODE,
      id: "",
      isValid: null,
      isLoading: false,
    };
  },
  computed: {
    ...mapState("onboarding", ["onboardingPatient"]),

    hasAppliedFormaCode() {
      return !!this.onboardingPatient?.formaCodeDiscountApplied;
    },

    isShowPromoCodeForm() {
      return !!$cookies.get(COOKIES.SHOW_PROMO_FORM.COOKIE_NAME);
    },
  },
  methods: {
    async applyCoupon() {
      try {
        this.isLoading = true;

        if (_.isEmpty(this.code)) {
          this.isValid = null;
          return;
        }

        await OnboardingService.applyCoupon({
          couponid: this.code,
        });

        await this.getOnboarding();

        this.$emit("apply-coupon", true);

        this.isValid = true;
      } catch (error) {
        this.isValid = false;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.promo-code-form {
  display: flex;
  margin-bottom: 1.5rem;
  align-items: center;
  gap: 1.5rem;

  &__label {
    flex-shrink: 0;
  }

  &__text-wrapper {
    border: 1px solid #edf2f9;
    background-color: rgba(242, 242, 242, 0.5);
    padding: 1rem;
    width: 100%;
    position: relative;
    display: flex;
    gap: 5px;
    button {
      background-color: #a783ff;
      border: 1px solid #a783ff;
      border-radius: 4px;
      color: white;
      cursor: pointer;
      font-family: arial, sans-serif;
      font-size: 14px;
      height: 36px;
      line-height: 27px;
      padding: 0 16px;
      text-align: center;
      user-select: none;
      -webkit-user-select: none;
      touch-action: manipulation;
      white-space: pre;
      &:disabled {
        opacity: 0.8;
        cursor: not-allowed;
      }
    }
  }
}
</style>
